(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fingies-unbox-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  var OPEN_MS = 780;

  function init(root) {
    if (!root || root.dataset.fpUnboxInit === 'true') return;
    root.dataset.fpUnboxInit = 'true';

    /* Sequence mode has one bag and N prizes. Carousel mode has one slide per
       pack, each with its own bag and exactly one prize, so bags[i] and
       prizes[i] belong to slides[i]. */
    var bags = Array.prototype.slice.call(root.querySelectorAll('[data-fp-unbox-bag]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fp-unbox-slide]'));
    var isCarousel = slides.length > 0;
    var again = root.querySelector('[data-fp-unbox-again]');
    var hint = root.querySelector('[data-fp-unbox-hint]');
    var spark = root.querySelector('[data-fp-unbox-spark]');
    var prizes = Array.prototype.slice.call(root.querySelectorAll('[data-fp-unbox-prize]'));
    if (!bags.length || !prizes.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wantSound = root.dataset.sound === 'on';
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-fp-unbox-prize] video'));
    var sfxOpen = root.querySelector('[data-fp-unbox-sfx="open"]');
    var sfxReveal = root.querySelector('[data-fp-unbox-sfx="reveal"]');
    var sfxVolume = Math.min(1, Math.max(0, (parseInt(root.dataset.sfxVolume, 10) || 0) / 100));
    [sfxOpen, sfxReveal].forEach(function (a) { if (a) a.volume = sfxVolume; });
    var controls = root.querySelector('[data-fp-unbox-media-controls]');
    var playBtn = root.querySelector('[data-fp-unbox-playpause]');
    var muteBtn = root.querySelector('[data-fp-unbox-mute]');
    var playLabel = root.querySelector('[data-fp-unbox-play-label]');
    var muteLabel = root.querySelector('[data-fp-unbox-mute-label]');
    var state = 'idle';
    var index = 0;
    var active = null;
    var timer = null;

    var PARTICLES = 26;
    var BURST_S = 1.1;
    var drops = Array.prototype.slice.call(root.querySelectorAll('.fp-unbox__drop'));

    if (spark && !spark.childElementCount) {
      for (var i = 0; i < PARTICLES; i++) {
        spark.appendChild(document.createElement('span'));
      }
    }

    function videoOf(prize) {
      return prize ? prize.querySelector('video') : null;
    }

    /* Aim the burst at the floating shapes. Measured on every reveal so it
       follows the current layout. About two thirds of the particles head for
       a shape; the rest fill the gaps so the burst still reads as a ring. */
    function aimSparks() {
      if (!spark) return;
      var box = spark.getBoundingClientRect();
      var cx = box.left + box.width / 2;
      var cy = box.top + box.height / 2;
      var targets = drops.map(function (d) {
        var r = d.getBoundingClientRect();
        var dx = r.left + r.width / 2 - cx;
        var dy = r.top + r.height / 2 - cy;
        return { angle: Math.atan2(dy, dx), dist: Math.sqrt(dx * dx + dy * dy) };
      }).filter(function (t) { return t.dist > 0; });
      var avg = targets.length
        ? targets.reduce(function (sum, t) { return sum + t.dist; }, 0) / targets.length
        : box.width / 2;

      Array.prototype.forEach.call(spark.children, function (dot, n) {
        var angle;
        var dist;
        if (targets.length && n % 3 !== 2) {
          var t = targets[n % targets.length];
          angle = t.angle + (Math.random() - 0.5) * 0.6;
          dist = t.dist * (0.7 + Math.random() * 0.3);
        } else {
          angle = Math.random() * Math.PI * 2;
          dist = avg * (0.55 + Math.random() * 0.35);
        }
        var delay = Math.random() * 0.12;
        dot.style.setProperty('--tx', (Math.cos(angle) * dist).toFixed(1) + 'px');
        dot.style.setProperty('--ty', (Math.sin(angle) * dist).toFixed(1) + 'px');
        dot.style.setProperty('--ps', (0.6 + Math.random() * 0.8).toFixed(2));
        dot.style.animationDelay = delay.toFixed(3) + 's';
        dot.style.animationDuration = (BURST_S - delay).toFixed(3) + 's';
      });
    }

    function hideAll() {
      prizes.forEach(function (p) {
        p.hidden = true;
        var v = videoOf(p);
        if (v) { v.fpWanted = false; v.pause(); v.muted = true; }
      });
      if (controls) controls.hidden = true;
    }

    /* A tap is a user gesture, which is what lets a video play with sound.
       The reveal happens 780ms later inside a timeout, and a timeout breaks
       that gesture chain: WebKit then treats the play() as autoplay and
       refuses audio. So on the tap we start the chosen video muted and stop
       it immediately, which marks it as user-activated. Only the chosen one:
       play() on a preload="none" video starts downloading it. */
    function primeMedia(v) {
      if (!v) return;
      try {
        v.fpWanted = false;
        v.preload = 'auto';
        v.muted = true;
        var p = v.play();
        if (p && p.then) {
          /* With reduced motion the reveal runs straight after this, so by
             the time the promise settles the video may be meant to play. */
          p.then(function () {
            if (v.fpWanted) return;
            v.pause();
            v.currentTime = 0;
          }).catch(function () {});
        } else {
          v.pause();
          v.currentTime = 0;
        }
      } catch (e) {}
    }

    /* The frame image sits in a hidden reveal, so a lazy image would only start
       loading once shown and the video would play a beat without its card.
       Load and decode it on the tap instead. */
    function primeFrame(prize) {
      var img = prize ? prize.querySelector('.fp-unbox__frame') : null;
      if (!img) return;
      img.loading = 'eager';
      if (img.decode) { img.decode().catch(function () {}); }
    }

    /* Same trick for the reveal sound, which also plays after the delay. */
    function primeSfx() {
      if (!sfxReveal) return;
      try {
        sfxReveal.fpWanted = false;
        sfxReveal.muted = true;
        var sp = sfxReveal.play();
        var settle = function () {
          if (sfxReveal.fpWanted) return;
          sfxReveal.pause();
          sfxReveal.currentTime = 0;
        };
        if (sp && sp.then) { sp.then(settle).catch(function () {}); } else { settle(); }
      } catch (e) {}
    }

    function playSfx(a) {
      if (!a) return;
      try {
        a.fpWanted = true;
        a.muted = false;
        a.currentTime = 0;
        var p = a.play();
        if (p && p.catch) { p.catch(function () {}); }
      } catch (e) {}
    }

    /* aria-pressed drives which icon shows:
       play/pause button  -> true means paused, so show the play icon
       mute button        -> true means muted, so show the muted icon */
    function syncControls() {
      var v = videoOf(active);
      if (!controls) return;
      if (!v) { controls.hidden = true; return; }
      controls.hidden = false;
      if (playBtn) {
        playBtn.setAttribute('aria-pressed', v.paused ? 'true' : 'false');
        if (playLabel) playLabel.textContent = v.paused ? 'Play video' : 'Pause video';
      }
      if (muteBtn) {
        muteBtn.setAttribute('aria-pressed', v.muted ? 'true' : 'false');
        if (muteLabel) muteLabel.textContent = v.muted ? 'Unmute video' : 'Mute video';
      }
    }

    function reveal() {
      hideAll();
      active.hidden = false;
      aimSparks();
      playSfx(sfxReveal);
      var video = videoOf(active);
      if (video) {
        video.fpWanted = true;
        video.currentTime = 0;
        video.muted = !wantSound;
        var p = video.play();
        if (p && p.then) {
          p.then(syncControls).catch(function () {
            /* browser refused audio: fall back to muted so it still plays */
            video.muted = true;
            var q = video.play();
            if (q && q.catch) { q.catch(function () {}); }
            syncControls();
          });
        }
      }
      syncControls();
      /* Warm up the next card's first frames while this one plays (sequence
         only: in the carousel the shopper picks, so there is no "next"). */
      if (!isCarousel) {
        var nextVideo = videoOf(prizes[(index + 1) % prizes.length]);
        if (nextVideo && nextVideo !== video && nextVideo.preload === 'none') {
          nextVideo.preload = 'metadata';
        }
      }
      setState('revealed');
    }

    function setState(next) {
      state = next;
      root.dataset.state = next;
      if (hint) {
        // Same line in every state, so the layout never collapses: before text, then after text.
        var text = next === 'idle' ? (root.dataset.hintIdle || '') : next === 'revealed' ? (root.dataset.hintAfter || '') : '';
        // "|" starts a second line: line 1 never wraps, the dot lines up with it (CR-022).
        if (text.indexOf('|') > -1) {
          var wrap = document.createElement('span');
          wrap.className = 'fp-unbox__hint-text';
          text.split('|').forEach(function (part) {
            var line = document.createElement('span');
            line.className = 'fp-unbox__hint-line';
            line.textContent = part.trim();
            wrap.appendChild(line);
          });
          hint.replaceChildren(wrap);
        } else {
          hint.textContent = text || ' ';
        }
        hint.toggleAttribute('data-empty', !text);
      }
    }

    function openPack() {
      if (state !== 'idle') return;
      active = prizes[index];
      playSfx(sfxOpen);
      primeMedia(videoOf(active));
      primeFrame(active);
      primeSfx();
      setState('opening');
      window.clearTimeout(timer);
      if (reduced) { reveal(); return; }
      timer = window.setTimeout(reveal, OPEN_MS);
    }

    /* ---- Carousel: index doubles as the centred slide. ---- */
    var nameEl = root.querySelector('[data-fp-unbox-name]');
    var ctaEl = root.querySelector('[data-fp-unbox-cta]');
    var ctaFollows = root.hasAttribute('data-cta-follows');
    var swiped = false;

    function neighbours() {
      var n = parseInt(window.getComputedStyle(root).getPropertyValue('--c-n'), 10);
      return n > 0 ? n : 1;
    }

    function layout() {
      var count = slides.length;
      var reach = neighbours();
      slides.forEach(function (slide, i) {
        var off = ((i - index) % count + count) % count;
        if (off > count / 2) off -= count;
        var far = Math.abs(off) > reach;
        slide.style.setProperty('--offset', off);
        slide.style.zIndex = String(10 - Math.abs(off));
        slide.toggleAttribute('data-active', off === 0);
        slide.toggleAttribute('data-far', far);
        slide.setAttribute('aria-hidden', off === 0 ? 'false' : 'true');
        /* roving tabindex: Tab lands on the centred pack, arrow keys move */
        bags[i].tabIndex = off === 0 ? 0 : -1;
      });
      var cur = slides[index];
      if (nameEl) nameEl.textContent = cur.dataset.title || '';
      if (ctaEl && ctaFollows && cur.dataset.url) ctaEl.href = cur.dataset.url;
    }

    function goTo(i, focus) {
      if (state !== 'idle' || slides.length < 2) return;
      index = (i % slides.length + slides.length) % slides.length;
      layout();
      if (focus) bags[index].focus({ preventScroll: true });
    }

    if (isCarousel) {
      bags.forEach(function (b, i) {
        b.addEventListener('click', function () {
          if (swiped) { swiped = false; return; }
          if (i === index) { openPack(); } else { goTo(i, true); }
        });
      });

      var prev = root.querySelector('.fp-unbox__nav [data-prev]');
      var next = root.querySelector('.fp-unbox__nav [data-next]');
      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });

      var track = root.querySelector('[data-fp-unbox-track]');
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1, true); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1, true); }
      });

      /* Swipe: past 40px moves one pack and swallows the click that follows;
         anything under that is a tap and falls through to the bag's click. */
      var startX = null;
      var startY = 0;
      track.addEventListener('pointerdown', function (e) {
        swiped = false;
        startX = e.clientX;
        startY = e.clientY;
      });
      track.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          goTo(index + (dx < 0 ? 1 : -1));
          window.setTimeout(function () { swiped = false; }, 400);
        }
      });
      track.addEventListener('pointercancel', function () { startX = null; });

      var mq = window.matchMedia('(max-width: 749px)');
      var relayout = function () { layout(); };
      if (mq.addEventListener) { mq.addEventListener('change', relayout); } else if (mq.addListener) { mq.addListener(relayout); }

      layout();
    } else {
      bags[0].addEventListener('click', openPack);
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        var v = videoOf(active);
        if (!v) return;
        if (v.paused) {
          var p = v.play();
          if (p && p.catch) { p.catch(function () {}); }
        } else {
          v.pause();
        }
        syncControls();
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        var v = videoOf(active);
        if (!v) return;
        v.muted = !v.muted;
        syncControls();
      });
    }

    /* keep the icons honest if playback changes for any other reason */
    videos.forEach(function (v) {
      ['play', 'pause', 'volumechange'].forEach(function (evt) {
        v.addEventListener(evt, function () {
          if (videoOf(active) === v) syncControls();
        });
      });
    });

    /* Again: sequence moves to the next card in order, looping back to the
       first. Carousel goes back to the same pack, centred. */
    if (again) {
      again.addEventListener('click', function () {
        window.clearTimeout(timer);
        if (!isCarousel) index = (index + 1) % prizes.length;
        hideAll();
        active = null;
        setState('idle');
        if (isCarousel) bags[index].focus({ preventScroll: true });
      });
    }

    hideAll();
    setState('idle');
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-fp-unbox]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koa-unbox"] && !Shopify.designMode) return;
  try {
    
(function () {
  var OPEN_MS = 780;

  function pick(prizes, weighted) {
    if (!weighted || prizes.length < 2) return prizes[0];
    var total = 0;
    var i;
    for (i = 0; i < prizes.length; i++) {
      total += Math.max(1, parseInt(prizes[i].dataset.weight, 10) || 1);
    }
    var roll = Math.random() * total;
    for (i = 0; i < prizes.length; i++) {
      roll -= Math.max(1, parseInt(prizes[i].dataset.weight, 10) || 1);
      if (roll <= 0) return prizes[i];
    }
    return prizes[prizes.length - 1];
  }

  function init(root) {
    if (!root || root.dataset.koaInit === 'true') return;
    root.dataset.koaInit = 'true';

    var bag = root.querySelector('[data-koa-bag]');
    var again = root.querySelector('[data-koa-again]');
    var hint = root.querySelector('[data-koa-hint]');
    var spark = root.querySelector('[data-koa-spark]');
    var download = root.querySelector('[data-koa-download]');
    var prizes = Array.prototype.slice.call(root.querySelectorAll('[data-koa-prize]'));
    if (!bag || !prizes.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var randomize = root.dataset.randomize === 'on';
    var wantSound = root.dataset.sound === 'on';
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-koa-prize] video'));
    var sfxOpen = root.querySelector('[data-koa-sfx="open"]');
    var sfxReveal = root.querySelector('[data-koa-sfx="reveal"]');
    var sfxVolume = Math.min(1, Math.max(0, (parseInt(root.dataset.sfxVolume, 10) || 0) / 100));
    [sfxOpen, sfxReveal].forEach(function (a) { if (a) a.volume = sfxVolume; });
    var controls = root.querySelector('[data-koa-media-controls]');
    var playBtn = root.querySelector('[data-koa-playpause]');
    var muteBtn = root.querySelector('[data-koa-mute]');
    var playLabel = root.querySelector('[data-koa-play-label]');
    var muteLabel = root.querySelector('[data-koa-mute-label]');
    var state = 'idle';
    var active = null;
    var timer = null;

    var PARTICLES = 26;
    var BURST_S = 1.1;
    var drops = Array.prototype.slice.call(root.querySelectorAll('.koa-unbox__drop'));

    if (spark && !spark.childElementCount) {
      for (var i = 0; i < PARTICLES; i++) {
        spark.appendChild(document.createElement('span'));
      }
    }

    /* Aim the burst at the floating shapes. Measured on every reveal so it
       follows the current layout (desktop, mobile, per-shape scale). About
       two thirds of the particles head for a shape; the rest fill the gaps
       so the burst still reads as a full ring. */
    function aimSparks() {
      if (!spark) return;
      var box = spark.getBoundingClientRect();
      var cx = box.left + box.width / 2;
      var cy = box.top + box.height / 2;
      var targets = drops.map(function (d) {
        var r = d.getBoundingClientRect();
        var dx = r.left + r.width / 2 - cx;
        var dy = r.top + r.height / 2 - cy;
        return { angle: Math.atan2(dy, dx), dist: Math.sqrt(dx * dx + dy * dy) };
      }).filter(function (t) { return t.dist > 0; });
      var avg = targets.length
        ? targets.reduce(function (sum, t) { return sum + t.dist; }, 0) / targets.length
        : box.width / 2;

      Array.prototype.forEach.call(spark.children, function (dot, n) {
        var angle;
        var dist;
        if (targets.length && n % 3 !== 2) {
          var t = targets[n % targets.length];
          angle = t.angle + (Math.random() - 0.5) * 0.6;
          dist = t.dist * (0.7 + Math.random() * 0.3);
        } else {
          angle = Math.random() * Math.PI * 2;
          dist = avg * (0.55 + Math.random() * 0.35);
        }
        var delay = Math.random() * 0.12;
        dot.style.setProperty('--tx', (Math.cos(angle) * dist).toFixed(1) + 'px');
        dot.style.setProperty('--ty', (Math.sin(angle) * dist).toFixed(1) + 'px');
        dot.style.setProperty('--ps', (0.6 + Math.random() * 0.8).toFixed(2));
        dot.style.animationDelay = delay.toFixed(3) + 's';
        dot.style.animationDuration = (BURST_S - delay).toFixed(3) + 's';
      });
    }

    function hideAll() {
      prizes.forEach(function (p) {
        p.hidden = true;
        var v = p.querySelector('video');
        if (v) { v.koaWanted = false; v.pause(); v.muted = true; }
      });
      if (controls) controls.hidden = true;
    }

    /* A tap is a user gesture, which is what lets a video play with sound.
       The reveal happens 780ms later inside a timeout, and a timeout breaks
       that gesture chain — WebKit then treats the play() as autoplay and
       refuses audio. So on the tap we start every video muted and stop it
       immediately: that marks each element as user-activated, and the later
       play() is allowed to carry sound. */
    function prime() {
      videos.forEach(function (v) {
        try {
          v.koaWanted = false;
          v.muted = true;
          var p = v.play();
          if (p && p.then) {
            /* play() resolves asynchronously. With reduced motion the reveal
               runs straight after this, so by the time the promise settles
               the chosen video may already be meant to play: leave it. */
            p.then(function () {
              if (v.koaWanted) return;
              v.pause();
              v.currentTime = 0;
            }).catch(function () {});
          } else {
            v.pause();
            v.currentTime = 0;
          }
        } catch (e) {}
      });
      /* Same trick for the reveal sound, which also plays after the delay.
         The flag stops a late prime from pausing it if the reveal already
         started (reduced motion reveals immediately). */
      if (sfxReveal) {
        try {
          sfxReveal.koaWanted = false;
          sfxReveal.muted = true;
          var sp = sfxReveal.play();
          var settle = function () {
            if (sfxReveal.koaWanted) return;
            sfxReveal.pause();
            sfxReveal.currentTime = 0;
          };
          if (sp && sp.then) { sp.then(settle).catch(function () {}); } else { settle(); }
        } catch (e) {}
      }
    }

    function playSfx(a) {
      if (!a) return;
      try {
        a.koaWanted = true;
        a.muted = false;
        a.currentTime = 0;
        var p = a.play();
        if (p && p.catch) { p.catch(function () {}); }
      } catch (e) {}
    }

    /* aria-pressed drives which icon shows:
       play/pause button  -> true means paused, so show the play icon
       mute button        -> true means muted, so show the muted icon */
    function syncControls() {
      var v = active ? active.querySelector('video') : null;
      if (!controls) return;
      if (!v) { controls.hidden = true; return; }
      controls.hidden = false;
      if (playBtn) {
        playBtn.setAttribute('aria-pressed', v.paused ? 'true' : 'false');
        if (playLabel) playLabel.textContent = v.paused ? 'Play video' : 'Pause video';
      }
      if (muteBtn) {
        muteBtn.setAttribute('aria-pressed', v.muted ? 'true' : 'false');
        if (muteLabel) muteLabel.textContent = v.muted ? 'Unmute video' : 'Mute video';
      }
    }

    function reveal() {
      active = pick(prizes, randomize);
      hideAll();
      active.hidden = false;
      aimSparks();
      playSfx(sfxReveal);
      var video = active.querySelector('video');
      if (video) {
        video.koaWanted = true;
        video.currentTime = 0;
        video.muted = !wantSound;
        var p = video.play();
        if (p && p.then) {
          p.then(syncControls).catch(function () {
            /* browser refused audio — fall back to muted so it still plays */
            video.muted = true;
            var q = video.play();
            if (q && q.catch) { q.catch(function () {}); }
            syncControls();
          });
        }
      }
      syncControls();
      if (download) {
        var media = active.querySelector(':scope > img');
        if (media) {
          download.href = media.currentSrc || media.src;
          download.hidden = false;
        } else {
          download.hidden = true;
        }
      }
      setState('revealed');
    }

    function setState(next) {
      state = next;
      root.dataset.state = next;
      if (hint) {
        hint.textContent = next === 'idle' ? (root.dataset.hintIdle || '') : '';
      }
    }

    bag.addEventListener('click', function () {
      if (state !== 'idle') return;
      playSfx(sfxOpen);
      prime();
      setState('opening');
      window.clearTimeout(timer);
      if (reduced) { reveal(); return; }
      timer = window.setTimeout(reveal, OPEN_MS);
    });

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        var v = active ? active.querySelector('video') : null;
        if (!v) return;
        if (v.paused) {
          var p = v.play();
          if (p && p.catch) { p.catch(function () {}); }
        } else {
          v.pause();
        }
        syncControls();
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        var v = active ? active.querySelector('video') : null;
        if (!v) return;
        v.muted = !v.muted;
        syncControls();
      });
    }

    /* keep the icons honest if playback changes for any other reason */
    videos.forEach(function (v) {
      ['play', 'pause', 'volumechange'].forEach(function (evt) {
        v.addEventListener(evt, function () {
          if (active && active.querySelector('video') === v) syncControls();
        });
      });
    });

    if (again) {
      again.addEventListener('click', function () {
        window.clearTimeout(timer);
        hideAll();
        setState('idle');
      });
    }

    hideAll();
    setState('idle');
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-koa-unbox]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
